export default __webpack_public_path__ + "static/media/ev-charge-point-slow-fast.4f5801d6.svg";